import React from 'react';
import { Box, Tab, Tabs } from '@material-ui/core';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import { Pagination } from '@material-ui/lab';
import NewEntrieEdit from 'src/components/insigthFactory/newEntrieEdit/NewEntrieEdit';
import NewEntriesCard from 'src/components/insigthFactory/NewEntriesCard/NewEntriesCard';
import EmptyMessage from 'src/components/insigthFactory/emptyMessage/EmptyMessage';
import Button from '../../../components/sharedComponents/CustomButtons/Button';

import {
  TabPanel,
  a11yProps,
} from '../../../components/sharedComponents/TapPanel/index';
import ReturnButton from '../ReturnButton';

const NewEntries = (props) => {
  const {
    units,
    entries,
    formEdit,
    openEdit,
    tabSelect,
    onOpenEdit,
    reloadList,
    onChangeTab,
    onCloseEdit,
    handleChange,
    onChangePage,
    onChangeForm,
    onSubmitEdit,
    onClickArchive,
    onClickUnarchive,
    totalPagesEntries,
    totalpagesArchived,
    currentPostsEntries,
    currentPostArchived,
    onClickReturn
  } = props;
  const title = 'No hay entradas nuevas';
  const subTitle = 'Realiza una campaña para que los usuarios puedan ingresar nuevas entradas';

  return (
    <>
      <CardTitle
        title="Entradas Nuevas"
        subTitle="En esta página encontraras las historias nuevas y cómo clasificarlas"
      />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <ReturnButton label='Volver' onClick={onClickReturn} />
        <Button style={{ margin: '0px 15px', height: '40px' }} onClick={reloadList} color='info'>Actualizar lista</Button>
      </div>

      {entries.length === 0 ? (
        <EmptyMessage title={title} subTitle={subTitle} />
      ) : (
        <>
          <NewEntrieEdit
            formEdit={formEdit}
            openEdit={openEdit}
            onCloseEdit={onCloseEdit}
            onChangeForm={onChangeForm}
            onSubmitEdit={onSubmitEdit}
          />

          <Tabs
            value={tabSelect}
            onChange={onChangeTab}
            centered
            TabIndicatorProps={{
              style: {
                backgroundColor: '#FAA500',
              },
            }}
          >
            <Tab label="Entradas Nuevas" {...a11yProps(0)} />
            <Tab label="Entradas Archivadas" {...a11yProps(1)} />
          </Tabs>
          <TabPanel value={tabSelect} index={0}>
            <Box>
              {currentPostsEntries?.map((entry) => (
                <NewEntriesCard
                  key={entry.id}
                  entry={entry}
                  units={units}
                  onOpenEdit={() => onOpenEdit(entry)}
                  handleChange={(event) => handleChange(event, entry.id)}
                  onClickArchive={(event) => onClickArchive(event, entry.id)}
                  onClickUnarchive={(event) => onClickUnarchive(event, entry.id)}
                />
              ))}

              <Pagination
                count={totalPagesEntries}
                onChange={onChangePage}
                defaultPage={1}
              />
            </Box>
          </TabPanel>
          <TabPanel value={tabSelect} index={1}>
            <Box>
              {currentPostArchived?.map((entry) => (
                <NewEntriesCard
                  key={entry.id}
                  entry={entry}
                  units={units}
                  onOpenEdit={() => onOpenEdit(entry)}
                  handleChange={(event) => handleChange(event, entry.id)}
                  onClickArchive={(event) => onClickArchive(event, entry.id)}
                  onClickUnarchive={(event) => onClickUnarchive(event, entry.id)}
                />
              ))}

              <Pagination
                defaultPage={1}
                onChange={onChangePage}
                count={totalpagesArchived}
              />
            </Box>
          </TabPanel>
        </>
      )}
    </>
  );
};

export default NewEntries;
